export const isModel = (type) =>
    type === 'FloorItem' || type === 'WallItem' || type === 'Door' || type === 'Window' ||
    type === 'TwinBed' || type === 'Crib' || type === 'ToddlerBed' || type === 'QueenBed' || type === 'Bassinet';

export const isColor = (type) => type === 'Color';

export const isTexture = (type) => type === 'Texture';

export const isDecal = (type) => type === 'Decal';

export const isWallPrint = (type) => type === 'WallPrint';

export const isPillow = (type) => type === 'Pillow';

export const isRug = (type) => type === 'Rug';

export const isCurtain = (type) => type === 'Curtain';

export const doesContainFiles = (type) => isModel(type) || isTexture(type) || isDecal(type) || isWallPrint(type) || isPillow(type) || isRug(type) || isCurtain(type);
